import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {

  transform(
    value: string | null | undefined,
    lang: 'fr' | 'en' | 'ar' = 'fr'
  ): string {

    if (!value) return '';

    // Normalisation (API: "2025-10-22 14:07:15")
    const normalized = value.replace(' ', 'T');
    const date = new Date(normalized);

    // Vérification date valide
    if (isNaN(date.getTime())) return '';

    const locales: Record<string, string> = {
      fr: 'fr',
      en: 'en',
      ar: 'ar'
    };

    return date.toLocaleDateString(locales[lang], {
      day: '2-digit',
      month: 'short',
      year: '2-digit'
    });
  }
}
